import { useEffect, useState } from 'react'
import IconButton from '@material-ui/core/IconButton';
import makeStyles from '@material-ui/core/styles/makeStyles';
import CheckIcon from '@material-ui/icons/Check';
import { CSSProperties } from '@material-ui/core/styles/withStyles';
import clsx from 'clsx';

import { dirStyleGenerator } from '../functions';
import { CheckBoxStylesProps } from '../types';

interface CheckBoxProps {
    checked?: boolean;
    error?: boolean;
    fontSize?: number | string;
    onChange?(value: boolean): void;
    readOnly?: boolean;
}

const CheckBox: React.FC<CheckBoxProps> = ({ children, onChange, checked, error, fontSize, readOnly }) => {
    const [check, setCheck] = useState(checked || false);

    const classes = useStyles({ error, fontSize });

    useEffect(() => {
        if (checked !== undefined) setCheck(checked);
    }, [checked]);

    return (
        <div
            className={classes.container}
            onClick={() => !!!readOnly && setCheck((prev) => { if (onChange) onChange(!prev); return !prev })}
        >
            <IconButton>
                <div className={classes.box}>
                    <div className={clsx(classes.checkIconContainer, check && classes.checked)}>
                        <CheckIcon className={classes.checkIcon} />
                    </div>
                </div>
            </IconButton>
            <div className={classes.description}>{children}</div>
        </div>
    );
}

export default CheckBox;

const useStyles = makeStyles(theme => ({
    container: {
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'flex-start',
        marginLeft: -12,
    },

    box: {
        position: 'relative',
        border: `1px solid`,
        borderColor: (props: CheckBoxStylesProps) => props.error ? theme.palette.error.main : theme.palette.primary.main,
        borderRadius: 3,
        height: 15,
        width: 15,

        [theme.breakpoints.down(500)]: {
            height: 20,
            width: 20,
            borderWidth: 1.5,
        } as CSSProperties,

        [theme.breakpoints.up(1600)]: {
            height: 20,
            width: 20,
        } as CSSProperties
    },

    checkIconContainer: {
        overflow: 'hidden',
        position: 'absolute',
        top: -8,
        ...dirStyleGenerator('', -2),
        direction: theme.direction,
        transition: 'width 0.3s ease',
        width: 0
    },

    checked: {
        width: 21,

        [theme.breakpoints.down(500)]: {
            width: 27,
        } as CSSProperties,

        [theme.breakpoints.up(1600)]: {
            width: 27,
        } as CSSProperties
    },

    checkIcon: {
        fill: theme.palette.primary.main,

        [theme.breakpoints.down(500)]: {
            height: 30,
            width: 30,
        } as CSSProperties,

        [theme.breakpoints.up(1600)]: {
            height: 30,
            width: 30,
        } as CSSProperties
    },

    description: {
        color: (props: CheckBoxStylesProps) => props.error ? theme.palette.error.main : theme.palette.primary.main,
        fontSize: (props: CheckBoxStylesProps) => props.fontSize ?? 13,
        maxWidth: 'calc(100% - 15px - 7px)',
        textAlign: 'initial',
        padding: '12px 0',
        margin: '-2px 0 0 7px',

        [theme.breakpoints.down(500)]: {
            fontSize: '16px !important',
            maxWidth: 'calc(100% - 20px - 7px)'
        } as CSSProperties,

        [theme.breakpoints.up(1600)]: {
            fontSize: '16px !important',
            maxWidth: 'calc(100% - 20px - 7px)'
        } as CSSProperties
    }
}));